import $ from 'jquery';

// Smooth scroll
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function () {
                    // Callback after animation
                });
            }
        }
    });

$.fn.isOnScreenWithOffset = function () {

    var win = $(window);

    var viewport = {
        top: win.scrollTop() + 400,
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

function activateNavItem(item) {

    let navItem = $('.right-nav__circle[data-scrollto=' + item + ']');
    $('.right-nav__circle').removeClass('active');
    navItem.addClass('active');
}

if ($('.right-nav').length) {

    $(document).on('scroll', function () {

        if ($('#section1').isOnScreenWithOffset()) {

            activateNavItem('section1');
            $('.right-nav__circle').removeClass('black');

        } else if ($('#section2').isOnScreenWithOffset()) {

            activateNavItem('section2');
            $('.right-nav__circle').addClass('black');

        } else if ($('#section3').isOnScreenWithOffset()) {

            activateNavItem('section3');
            $('.right-nav__circle').removeClass('black');

        } else if ($('#section4').isOnScreenWithOffset()) {

            activateNavItem('section4');
            $('.right-nav__circle').removeClass('black');

        } else if ($('#section5').isOnScreenWithOffset()) {

            activateNavItem('section5');
            $('.right-nav__circle').removeClass('black');

        } else if ($('#section6').isOnScreenWithOffset()) {

            activateNavItem('section6');
            $('.right-nav__circle').removeClass('black');

        } else if ($('#compare').isOnScreenWithOffset()) {

            activateNavItem('compare');
            $('.right-nav__circle').addClass('black');

        } else if ($('#find-a-dealer').isOnScreenWithOffset()) {

            activateNavItem('find-a-dealer');
            $('.right-nav__circle').removeClass('black');

        }

        });

}